import { SVGProps } from 'react';

type CoinType = 'bronze' | 'silver' | 'gold' | 'platinum';

const coinColors: Record<
  CoinType,
  { c1: string; c2: string; c3: string; c4: string; c5: string; c6: string }
> = {
  bronze: {
    c1: '#8C5A3C',
    c2: '#A6704F',
    c3: '#CD9B7F',
    c4: '#A0522D',
    c5: '#B06D45',
    c6: '#C18E6D',
  },
  silver: {
    c1: '#9E9E9E',
    c2: '#BDBDBD',
    c3: '#D1D1D1',
    c4: '#B7BAC5',
    c5: '#C4C4C4',
    c6: '#D1D1D1',
  },
  gold: {
    c1: '#8A6621',
    c2: '#B8860B',
    c3: '#E9C34F',
    c4: '#B8860B',
    c5: '#D4AF37',
    c6: '#FFD700',
  },
  platinum: {
    c1: '#A5A9B4',
    c2: '#B8BCC6',
    c3: '#D6D9E0',
    c4: '#B7BAC5',
    c5: '#BCBFC8',
    c6: '#CFD2D9',
  },
};

interface RewardCoinProps extends SVGProps<SVGSVGElement> {
  coinType?: CoinType;
}

export default function RewardCoin({
  coinType = 'bronze',
  ...props
}: RewardCoinProps) {
  const { c1, c2, c3, c4, c5, c6 } = coinColors[coinType];

  return (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2017_48)">
        <path
          d="M56.0098 1.6543V1.89063C81.3701 1.89063 104.932 16.1938 113.898 40.6484C123.159 65.9091 113.307 94.7241 90.9863 109.578C85.5364 113.204 78.6583 116.805 72.0801 117.691C73.305 118.169 75.0892 117.492 76.334 117.188C80.1422 116.259 83.8965 114.927 87.4414 113.253C103.05 105.88 114.405 91.9503 119.009 75.3887C126.494 48.4614 112.612 18.5911 87.2051 6.92647C76.9354 2.21159 67.0579 1.65309 56.0098 1.6543Z"
          fill={c1}
        />
        <path
          d="M108.711 90.9863H108.475C104.651 97.855 98.6377 103.989 92.168 108.393C81.7431 115.491 69.1789 119.656 56.4824 119.1C21.1976 117.555 -5.44365 83.6939 1.46522 49.1562C2.9278 41.8447 5.87554 34.8007 10.0046 28.5957C15.0883 20.9561 21.7883 14.5441 29.7774 9.99216C39.0478 4.71018 49.3841 2.10987 60.0274 2.12695C68.901 2.14118 78.2528 4.85025 86.0235 9.05342C89.4462 10.9047 92.4308 13.3173 95.7129 15.3613C94.5093 12.9912 90.6404 11.1841 88.3867 9.8904C80.7037 5.47973 72.1796 2.75423 63.336 2.10597C30.8044 -0.278685 1.45063 24.9851 0.00932352 57.9004C-1.48834 92.1025 28.4506 122.503 63.0996 119.15C77.1961 117.785 90.3133 112.232 100.439 102.094C103.246 99.284 107.774 94.9748 108.711 90.9863Z"
          fill={c2}
        />
        <path
          d="M55.3008 2.22724C41.4744 4.04265 29.1028 8.26351 18.6699 17.9821C13.5726 22.7304 9.42652 28.517 6.32249 34.7402C-10.0806 67.6267 9.05272 108.463 44.666 117.366C51.7911 119.148 59.142 119.526 66.4082 118.57C94.1247 114.926 115.986 91.0338 117.21 63.0996C118.444 34.9057 98.1095 8.89359 70.4258 3.35581C65.6014 2.39076 60.2192 1.58144 55.3008 2.22724Z"
          fill={c3}
        />
        <path
          d="M55.0644 10.2624C44.1841 11.691 34.1615 14.8867 25.6236 22.1472C21.0401 26.0452 17.3641 30.9323 14.449 36.1582C3.09277 56.5169 7.77798 83.913 25.6236 99.0891C36.3007 108.169 50.8791 112.435 64.7539 110.771C72.375 109.856 79.7971 107.272 86.2598 103.112C110.607 87.4381 116.861 51.8896 98.5372 29.1147C92.0928 21.1048 83.2927 15.2955 73.498 12.2832C67.7746 10.523 61.0487 9.47667 55.0644 10.2624Z"
          fill={c4}
        />
        <path
          d="M57.6207 12.235C47.8161 13.523 38.8002 16.2464 30.8187 22.3774C26.0659 26.0282 22.1208 30.6957 18.9633 35.7675C6.34494 56.0362 11.411 83.3942 29.8342 98.4606C40.5238 107.202 54.6701 110.888 68.2554 108.962C74.9927 108.007 81.3804 105.422 87.1617 101.891C91.7765 99.0732 95.8293 95.3045 99.1646 91.0683C115.767 69.9824 111.917 37.5851 89.9976 21.6883C85.3606 18.3253 80.1491 15.6768 74.6363 14.0941C69.3144 12.5661 63.1616 11.5071 57.6207 12.235Z"
          fill={c3}
        />
        <path
          d="M108.711 30.25C110.71 35.7418 113.84 40.5499 115.356 46.3203C118.273 57.4296 117.585 69.06 113.829 79.8789C112.482 83.7589 110.096 87.1812 108.711 90.9863C111.553 88.5512 113.142 83.1149 114.304 79.6426C118.272 67.7829 118.587 54.7107 114.697 42.7754C113.455 38.9625 111.837 32.9281 108.711 30.25Z"
          fill={c5}
        />
        <path d="M52.2285 78.9336V79.1699H58.8457L52.2285 78.9336Z" fill={c6} />
        <g clipPath="url(#clip1_2017_48)">
          <path
            d="M64.3535 62.8058V74.8991L44.343 82.5964V70.5031L46.2841 69.7575C46.2841 69.7575 46.2927 69.7489 46.3057 69.7489C46.3574 69.7144 46.4006 69.6541 46.4006 69.5894V68.2663C46.4006 68.2663 46.4135 68.2275 46.4351 68.2146L51.4992 66.2752C51.4992 66.2752 51.5207 66.2752 51.5207 66.2881V67.4905C51.5207 67.6112 51.6501 67.6974 51.7623 67.65L64.3578 62.8058H64.3535Z"
            fill={c4}
          />
          <path
            d="M76 43.1919V55.2852L44.343 67.469V55.3757L46.2841 54.6215C46.2841 54.6215 46.2927 54.6129 46.3057 54.6129C46.3574 54.5784 46.4006 54.5181 46.4006 54.4534V53.1303C46.4006 53.1303 46.4135 53.0915 46.4351 53.0829L51.4992 51.1349C51.4992 51.1349 51.5207 51.1349 51.5207 51.1478V52.3503C51.5207 52.4623 51.6286 52.5442 51.7364 52.527C51.7494 52.527 51.7623 52.5183 51.7623 52.5183L76 43.1876V43.1919Z"
            fill={c4}
          />
          <path
            d="M75.9957 28.0602V40.1535L44.343 52.3416L41 39.1881L42.9411 38.4339C43.0101 38.408 43.0532 38.3391 43.0532 38.2658L42.6478 36.9427C42.6478 36.9427 42.6607 36.9039 42.6823 36.8953L47.7464 34.9473C47.7464 34.9473 47.7593 34.9473 47.7636 34.9559L48.1691 36.1669C48.2122 36.3049 48.2985 36.3738 48.4106 36.335L72.657 27L72.9245 28.0688L42.6737 39.7182L44.343 46.8466V40.2483L73.2005 29.1377L74.3307 28.7067L76 28.0602H75.9957Z"
            fill={c4}
          />
          <path
            d="M44.343 85.6391L64.3535 77.9375V95L54.3461 91.1384L44.343 95V85.6391Z"
            fill={c4}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2017_48">
          <rect width="121" height="121" fill="white" />
        </clipPath>
        <clipPath id="clip1_2017_48">
          <rect
            width="35"
            height="68"
            fill="white"
            transform="translate(41 27)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
